import { useLocation } from 'react-router-dom';

const pageTitles: Record<string, string> = {
  '/': 'Dashboard',
  '/businesses': 'Business Management',
  '/trainers': 'Trainer Management',
  '/facilities': 'Facility Management',
  '/products': 'Product Management',
  '/trainings': 'Training Management',
  '/audit-logs': 'Audit Logs',
};

export function Header() {
  const location = useLocation();
  const title = pageTitles[location.pathname] || 'Admin Panel';

  return (
    <header className="bg-surface-app-elevated border-b border-white/10 px-8 py-4">
      <div className="flex items-center justify-between">
        <h1 className="font-display text-2xl font-semibold tracking-tight text-ink-primary">{title}</h1>
        <div className="flex items-center gap-4">
          <div className="text-sm text-ink-muted">
            {new Date().toLocaleDateString('en-US', {
              weekday: 'long',
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </div>
        </div>
      </div>
    </header>
  );
}
